



























































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { DxSelectBox, DxDateBox, DxTagBox } from 'devextreme-vue';
import { DxNumberBox } from 'devextreme-vue/number-box';

import { ConsumptionsPageArgs } from './types';
import { Page } from '@/core/components/controls';
import ConsumptionsTable from './ConsumptionsTable.vue';
import { TableOptions, getTableCaption } from '@/core/components/table';
import container from '@/container';
import {
    WindowsServiceContract,
    CONTRACTS,
    FetchServiceContract,
} from '@/core/contracts';
import { localize } from '../../core/filters';

import { DateTime, Duration } from 'luxon';
import { SettingsState, ContextsState, RoleState } from '@/store';
import { Inject } from '@/core/helpers';
import { PermissionType, ResourceType } from '@/dto';

@Component({
    components: {
        ConsumptionsTable,
        TableOptions,
        DxSelectBox,
        DxDateBox,
        DxNumberBox,
        DxTagBox,
    },
})
export default class ConsumptionsPage extends Page {
    @Prop({ default: () => ({}) })
    public args!: ConsumptionsPageArgs;

    public canAccept: boolean = false;
    public canRefuse: boolean = false;
    public table: any = null;
    public isSelectDismissCommentVisible: boolean = false;
    public isSelectEditVisible: boolean = false;
    public selectedCommentValue: string = this.getDefaultComment();
    public editInternalTimeValue: any = null;
    public editInternalQuantityValue: any = null;
    public editUsedResourceTypes: any = null;
    public vehicleResourceTypes: ResourceType[] = [];

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;

    public nextCommentAction: () => void = () => {};
    public nextEditAction: () => void = () => {};

    public async mounted() {
        this.setControlsVisibility();
        this.table = this.getTable().getDataGridInstance();
        this.setAvailableVehicleTypes();
    }

    public get tableKey(): string {
        let key = 'consumptions-control';
        if (this.args.type) {
            key = this.args.type + '-' + key;
        }
        return key;
    }

    public get canEditConsumptions() {
        return (
            RoleState.permissions &&
            PermissionType.Demands_write in RoleState.permissions
        );
    }

    public get colorIndication() {
        return SettingsState.contextSettings.global.colorIndication || true;
    }

    public getTable(): ConsumptionsTable {
        const element = this.$refs['table-control'] as unknown;
        return element as ConsumptionsTable;
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    public get changeDeliveryProposalComments() {
        const comments = localize('ChangeDeliveryProposalComments');
        return Array.isArray(comments) ? comments : [];
    }

    @Watch('isSelectDismissCommentVisible')
    public onSelectDismissCommentVisibleChange(newValue: boolean) {
        if (newValue === true) {
            Array.from(document.getElementsByClassName('s-dialog')).forEach(
                node => {
                    document
                        .getElementsByClassName('s-tiles')[0]
                        .appendChild(node);
                }
            );
        }
    }

    @Watch('isSelectEditVisible')
    public onSelectEditVisibleChange(newValue: boolean) {
        if (newValue === true) {
            Array.from(document.getElementsByClassName('s-dialog')).forEach(
                node => {
                    document
                        .getElementsByClassName('s-tiles')[0]
                        .appendChild(node);
                }
            );
        }
    }

    public getDefaultComment() {
        const comments = localize('ChangeDeliveryProposalComments');
        const arr = Array.isArray(comments) ? comments : [];
        return arr.length > 0 ? arr[0] : '';
    }

    public openEditData() {
        container
            .get<WindowsServiceContract>(CONTRACTS.WindowsService)
            .open('consumptions-edit-page', {
                type: this.args.type || '',
                extdata: this.args.extdata,
                productAlias: this.args.productAlias,
            } as ConsumptionsPageArgs);
    }

    public setImportantDemandFlag() {
        const table = this.getTable();
        const items = table.getSelectedItems();

        if (items.length === 0) {
            return container
                .get<WindowsServiceContract>(CONTRACTS.WindowsService)
                .showDialog(localize('RecordsNotSelected'));
        }

        // set 'important' flag for non-important rows,
        // otherwise disable 'important' for all rows
        const important = items.some(item => !item.important);

        table.setImportantDemandFlag(
            items.filter(item => item.important !== important), // update only necessary rows
            important
        );
    }

    public openConsumptionEditData() {
        // get grid data
        const items = this.getTable().getSelectedItems();

        if (items.length === 0) {
            return container
                .get<WindowsServiceContract>(CONTRACTS.WindowsService)
                .showDialog(localize('RecordsNotSelected'));
        }

        // set default values
        this.setDefaultEditValues();

        // show dialog
        this.isSelectEditVisible = true;

        // bind action
        this.nextEditAction = () => {
            // get data
            const timeValue = this.getDateTimeAsString(
                this.editInternalTimeValue
            );
            const quantityValue = this.editInternalQuantityValue;
            const usedResourceTypes = this.editUsedResourceTypes;

            // send data to save
            this.getTable().processEdit(
                timeValue,
                quantityValue,
                usedResourceTypes
            );

            // hide wiindow
            this.isSelectEditVisible = false;
        };
    }

    private setDefaultEditValues() {
        this.editInternalTimeValue = null;
        this.editInternalQuantityValue = null;
        this.editUsedResourceTypes = null;

        const value = null;
        const items = this.getTable().getSelectedItems();
        for (const item of items) {
            if (this.editInternalTimeValue == null && item.internalTime) {
                this.editInternalTimeValue = item.internalTime;
            }

            if (
                this.editInternalQuantityValue == null &&
                item.internalQuantityVolume
            ) {
                this.editInternalQuantityValue = item.internalQuantityVolume;
            }

            if (
                this.editUsedResourceTypes == null &&
                item.usageResourceTypeIds
            ) {
                this.editUsedResourceTypes = item.usageResourceTypeIds;
            }

            if (
                this.editInternalTimeValue != null &&
                this.editInternalQuantityValue != null
            ) {
                break;
            }
        }
    }

    private setAvailableVehicleTypes() {
        const currentContextId = ContextsState.currentContextId;
        this._fetchService!.get<ResourceType[]>(
            `/contexts/${currentContextId}/consumptions/available-vehicle-types`
        ).then((data: ResourceType[]) => {
            this.vehicleResourceTypes = data;
        });
    }

    private getDateTimeAsString(value: any) {
        if (value != null) {
            const offset = SettingsState.contextSettings.global.timeOffset || 0;
            let time = DateTime.fromISO(new Date(value).toISOString());
            time = time.minus(Duration.fromObject({ hours: offset }));
            const strValue = time.toFormat(`yyyy-MM-dd'T'HH:mm:ss`);
            return strValue;
        }
        return null;
    }

    private setControlsVisibility() {
        const isDeliveryProposals = this.args.type === 'delivery-proposals';
        this.canAccept = isDeliveryProposals;
        this.canRefuse = isDeliveryProposals;
    }
}
